import { gql } from '@apollo/client';
import apolloClientAdapter from '@segurodeceso/core/adapters/apolloClient.adapter';

const GET_UF = gql`
  query GetUF {
    getUF {
      ... on GetUfT {
        value
      }
      ... on GetUfErrorT {
        message
      }
    }
  }
`;

type GetUfResponseT = {
  getUF: {
    __typename: string;
    value?: number;
  };
};

const getUf = async (signal: AbortSignal) => {
  try {
    const { getUF } = await apolloClientAdapter<GetUfResponseT>(
      process.env.FEDERATION_GATEWAY || ''
    )(GET_UF, {
      context: {
        fetchOptions: {
          signal,
        },
      },
    });

    switch (getUF.__typename) {
      case 'GetUfT':
        return getUF.value;
      default:
        throw new Error('Unknown error occurred');
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('Request was cancelled');
    } else {
      throw error;
    }
  }
};

export default getUf;
